import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/api";
import { v4 as uuidv4 } from 'uuid';
import { Oval } from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from "../../utils/icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import AlertMessage from './../AlertMessage';


export default function OffreCreate({open, setOpen}){    
   
    const [loading, setLoading] = useState()
    const [name, setName] = useState(null)
    const [price, setPrice] = useState(null)
    const [duration, setDuration] = useState(null)
    const [bilingCycle, setbilingCycle] = useState('Monthly')
    const [periodCycle, setPeriodCycle] = useState('Monthly')
    const [nbBoost, setNbBoost] = useState(null)
    const [discount, setDiscount] = useState(null)
    const [trial_period, setTrial_period] = useState(null)
    const [feature, setFeature] = useState(null)
    const [alert, setAlert] = useState(null)
    const [isVisible, setIsVisible] = useState(true)


    
    const create = async ()=>{

        try{

            if(name && price && duration && bilingCycle && periodCycle && nbBoost && discount && feature && trial_period){
                
                setLoading(true)
                
                await api.post('/offer/create', {
                   
                    name : name,
                    price : price,
                    duration : duration,
                    bilingCycle : bilingCycle,
                    periodCycle : periodCycle,
                    nbBoost : nbBoost,
                    discount : discount,
                    features : feature,
                    trial_period : trial_period,
                    isVisible : isVisible
                });
    
                setLoading(false)
            }else{

                setAlert(true)
                
            }
            
        }catch(e){
            setLoading(false)
            console.log(e)
        }
    }
    

    return open ? (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-full max-w-md mx-auto transition-all duration-300 ease-out transform bg-white rounded-lg shadow-xl dark:bg-gray-800">
                
                {/* Bouton de fermeture */}
                <span
                className="absolute p-2 bg-gray-200 rounded-full cursor-pointer top-4 right-4 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                onClick={() => setOpen(false)}
                >
                <FontAwesomeIcon icon={faClose} className="text-gray-600 dark:text-gray-400" />
                </span>

                {/* Formulaire */}
                <form className="px-6 py-6" action="" method="POST">

                {/* Champ Nom */}

                {alert && <AlertMessage
                    message={'Remplissez la formulaire'}
                    type={'error'}
                    onClose={()=>setAlert(false)}
                />}
                <input
                    className="block w-full px-4 py-3 mb-4 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    type="text"
                    value={name}
                    placeholder="Nom"
                    onChange={(event) => setName(event.target.value)}
                />

                {/* Champ Prix */}
                <div className="flex items-center gap-4 mb-4">
                    <input
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    type="number"
                    placeholder="Prix"
                    value={price}
                    onChange={(event) => setPrice(event.target.value)}
                    />
                </div>

                {/* Champ Durée et Cycle de facturation */}
                <div className="flex items-center gap-4 mb-4">
                    <input
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    type="number"
                    placeholder="Durée"
                    value={duration}
                    onChange={(event) => setDuration(event.target.value)}
                    />
                    <select
                    value={bilingCycle}
                    onChange={(event) => setbilingCycle(event.target.value)}
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    >
                    <option value="Monthly">Mois</option>
                    <option value="Week">Semaine</option>
                    <option value="Day">Jour</option>
                    </select>
                </div>

                {/* Champ Période d'essai */}
                <div className="flex items-center gap-4 mb-4">
                    <input
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    type="number"
                    value={trial_period}
                    placeholder="Période d'essai"
                    onChange={(event) => setTrial_period(event.target.value)}
                    />
                    <select
                    value={periodCycle}
                    onChange={(event) => setPeriodCycle(event.target.value)}
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    >
                    <option value="Monthly">Mois</option>
                    <option value="Week">Semaine</option>
                    <option value="Day">Jour</option>
                    </select>
                </div>

                {/* Champ Réduction */}
                <div className="flex items-center gap-4 mb-4">
                    <input
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    type="number"
                    value={discount}
                    placeholder="Réduction (%)"
                    onChange={(event) => setDiscount(event.target.value)}
                    />
                </div>

                {/* Champ Nombre de boost */}
                <div className="flex items-center gap-4 mb-4">
                    <input
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    type="number"
                    value={nbBoost}
                    placeholder="Nombre de boost"
                    onChange={(event) => setNbBoost(event.target.value)}
                    />
                </div>

                {/* Champ Description */}
                <div className="mb-6">
                    <textarea
                    className="block w-full px-4 py-3 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Description"
                    value={feature}
                    onChange={(event) => setFeature(event.target.value)}
                    ></textarea>
                </div>

                <div className="mb-6">
                    <input 
                        type="checkbox"
                        checked={isVisible}
                        onChange={(event)=>{
                            setIsVisible(!isVisible)
                        }}
                        id='isVisible'
                        className="rounded-full"
                    />

                    <label for={'isVisible'} className="mx-2 text-sm text-gray-800 dark:text-gray-100">
                        l'offre peut etre visible aux clients ?
                    </label>
                </div>
                {/* Bouton Enregistrer */}
                <div className="flex items-center justify-center">
                    <button
                    type="button"
                    onClick={() => create()}
                    className="w-full px-4 py-3 font-semibold text-white transition duration-200 bg-indigo-600 rounded-lg shadow-lg hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-300"
                    >
                    {!loading ? 'Enregistrer' : 
                        <Oval
                        height={20}
                        width={20}
                        color="#ffffff"
                        ariaLabel="loading"
                        visible={true}
                        />
                    }
                    </button>
                </div>

                </form>
            </div>

            
        </div>

    ) : null
}